import {type SocketDataTypes} from '../../../shared/SocketDataTypes.ts'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables.ts'
import {PlayerEnums} from '../../../shared/GameEnums.ts'
import {clientI18n} from './ClientI18n.ts'
import {setElementOnClick} from './ui_utils/DomUtils.ts'
import {audioManager, AudioType} from './Sound.ts'
import {SocketLobbySend} from './socket/SocketLobbySend.ts'
import {RoomType} from '@colonist/lobby-types'
import {SDKRequest} from '../../../shared/DiscordActivityTypes.ts'
import {DiscordInstance} from '../../../client/web/scripts/discord/DiscordInstance.ts'
import {type DiscordContentFrameController} from '../../../client/web/scripts/discord/content_frame/DiscordContentFrameController.ts'

export class UIDiscordCtaUtils {
    static updateDiscordCTAContent(button: HTMLElement, roomData: SocketDataTypes.ChannelRoomUpdate) {
        if(!UIUtilsEjsVariables.isUserOnDiscord) throw new Error('This should only be called on the discord integration server')

        const triggerInviteFriendsPopup = roomData.type == PlayerEnums.ChannelStatus.Closed
        setElementOnClick(button, () => this.defaultMultiplayerCTAAction(triggerInviteFriendsPopup))

        if(roomData.type == PlayerEnums.ChannelStatus.Closed) {
            button.innerText = clientI18n.t('strings:homePage.ctas.play.title', {context: 'discord'})
            return
        }

        if(roomData.type == PlayerEnums.ChannelStatus.Game) {
            button.innerText = clientI18n.t('strings:homePage.ctas.spectate')
            return
        }

        if(roomData.type == PlayerEnums.ChannelStatus.Reconnect) {
            button.innerText = clientI18n.t('strings:homePage.ctas.rejoinGame')
            return
        }

        const playersInRoom = roomData.playersInRoom
        const maxPlayers = roomData.maxPlayers
        const isGameFull = playersInRoom >= maxPlayers

        if(isGameFull) {
            button.innerText = clientI18n.t('strings:homePage.ctas.roomFull')
            return
        }

        button.innerText = clientI18n.t('strings:homePage.ctas.joinRoom')
    }

    private static shouldTriggerInviteFriendsPopup(triggerInviteFriendsPopup: boolean, discordInstance: DiscordContentFrameController): boolean {
        if(!triggerInviteFriendsPopup) return false
        if(!discordInstance.inDiscordServer) return false
        if(!discordInstance.canInviteFriends) return false
        return true
    }

    private static defaultMultiplayerCTAAction(triggerInviteFriendsPopup: boolean) {
        audioManager.play(AudioType.Click)

        const channelId = DiscordInstance.getDiscordInstance().voiceChannelId
        SocketLobbySend.clickedJoinChannelRoomOrGame(channelId, RoomType.DiscordActivity)

        if(this.shouldTriggerInviteFriendsPopup(triggerInviteFriendsPopup, DiscordInstance.getDiscordInstance())) DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.InviteFriends)
    }
}
